import { SubjectData } from 'shell/models/person';
import { AccordionFamilyCoexistence as FamilyCoexistenceVM } from 'shell/view-models/accordion-family-coexistence';
import { DateTime } from 'luxon';
import { FamilyVM } from 'shell/view-models/family';

export const transformFamilyCoexistence = (
  person: SubjectData
): FamilyCoexistenceVM | undefined => {
  let type = 'Famiglia Convivenza';

  if (
    person?.famigliaConvivenza?.tipoScheda === '3' ||
    person?.famigliaConvivenza?.tipoScheda === '5'
  ) {
    type = 'Famiglia';
  }

  if (person?.famigliaConvivenza?.tipoScheda === '4') {
    type = 'Convivenza';
  }

  const familyComponents: Array<FamilyVM> =
    person?.famigliaConvivenza?.elencoSoggettiFamiglia?.soggettoFamiglia?.map((subject) => ({
      birthDate: subject.generalita?.dataNascita
        ? DateTime.fromISO(subject.generalita.dataNascita).toFormat('dd/MM/yyyy')
        : '',
      fiscalCode: subject.generalita?.codiceFiscale?.codFiscale || '',
      name: subject.generalita?.nome || '',
      surname: subject.generalita?.cognome || '',
      relationship: subject.legameSoggetto?.codiceLegame || '',
    })) || [];

  const originReturnData: FamilyCoexistenceVM | undefined = person?.famigliaConvivenza
    ? {
        type,
        tipoScheda: person?.famigliaConvivenza?.tipoScheda || '',
        municipalityIdentifier:
          person.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenza || '',
        codeIstat:
          person.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenzaComuneIstat ||
          '',
        identifierAnpr: person.famigliaConvivenza?.idFamigliaConvivenzaANPR || '',
        originDate: person.famigliaConvivenza?.dataOrigineFamigliaConvivenza
          ? DateTime.fromISO(person.famigliaConvivenza?.dataOrigineFamigliaConvivenza)
          : null,
        familyAire: person.famigliaConvivenza?.famigliaAire || '',
        reasonConstitution: person.famigliaConvivenza?.motivoCostituzione || '',
        cohabitingFamily: person.famigliaConvivenza?.denominazioneConvivenza || '',
        handlingType: person.famigliaConvivenza?.tipoMovimentazione || '',
        especiallyCoexistence: person.famigliaConvivenza?.specieConvivenza || '',
        especiallyCoexistenceDescription:
          person.famigliaConvivenza?.descrizioneSpecieConvivenza || '',
        nameCoexistence: person.famigliaConvivenza?.denominazioneConvivenza || '',
        membershipDate: person.legameSoggetto?.dataDecorrenzaLegame
          ? DateTime.fromISO(person.legameSoggetto?.dataDecorrenzaLegame)
          : null,
        bondDate: person.legameSoggetto?.dataDecorrenza
          ? DateTime.fromISO(person.legameSoggetto?.dataDecorrenza)
          : null,
        relationship: person.legameSoggetto?.codiceLegame || '',
        descrizioneCodiceLegame: person.legameSoggetto?.descrizioneCodiceLegame,
        progComponent: person.legameSoggetto?.progressivoComponente || '',
        coexistenceBond: person.legameSoggetto?.codiceLegame || '',
        familyComponents,
      }
    : undefined;

  return originReturnData;
};
